import { render, staticRenderFns } from "./ChallengeCustomers.vue?vue&type=template&id=610ab90c"
import script from "./ChallengeCustomers.vue?vue&type=script&lang=js"
export * from "./ChallengeCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports